import React from "react";
import { Badge, truncateAddress } from "../shared";

function formatTimestamp(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  return d.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

const STATUS_VARIANT = {
  success: "green",
  denied: "red",
  failed: "amber",
  pending: "gray",
};

export default function AuditEntry({ entry }) {
  return (
    <div className="mcp-audit-entry">
      <div className="mcp-audit-left">
        <Badge variant="blue">{entry.tool}</Badge>
        <Badge variant={STATUS_VARIANT[entry.status] || "gray"}>
          {entry.status}
        </Badge>
      </div>
      <div className="mcp-audit-center">
        {entry.amount && (
          <span className="mcp-audit-amount">
            {entry.amount} {entry.symbol || ""}
          </span>
        )}
        {entry.txHash && (
          <a
            href={entry.explorerUrl || `#`}
            target="_blank"
            rel="noopener noreferrer"
            className="mcp-audit-tx"
          >
            {truncateAddress(entry.txHash, 8, 6)}
          </a>
        )}
      </div>
      <div className="mcp-audit-right">
        <span className="mcp-audit-time">{formatTimestamp(entry.timestamp)}</span>
      </div>
    </div>
  );
}
